export default {
    'sales-contracts': 'عقود البيع ',
    'the-sales-contract': 'عقد البيع؟',
    'add-a-sales-contract': 'إضافة عقد بيع',

    'sales-contract': 'عقد البيع',
}